export const disabledMiddleware = () => next => action => {
    next(action);
};
//# sourceMappingURL=disabledMiddleware.js.map